import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AnnotateMatch { term: string; leafId: string; url: string; count: number; }
export interface AnnotateResult { html: string; matches: AnnotateMatch[]; }
export interface GlossaryListResult { count: number; terms: GlossaryTerm[]; }
export interface GlossaryTerm {
  term: string; leafId: string; letter?: string; meaning?: string;
  category?: string; tile?: string; url: string; ref?: string;
}

// Wires directly to the glossary master. Annotate surfaces linked terms in copy.
@Injectable({ providedIn: 'root' })
export class GlossaryService {
  constructor(private http: HttpClient) {}

  annotate(text: string, firstOnly = true): Observable<AnnotateResult> {
    return this.http.post<AnnotateResult>('/api/glossary/annotate', { text, firstOnly });
  }

  list(letter = '', q = '', take = 100): Observable<GlossaryListResult> {
    const params: Record<string, string | number> = { take };
    if (letter) params['letter'] = letter;
    if (q) params['q'] = q;
    return this.http.get<GlossaryListResult>('/api/glossary', { params });
  }
}
